import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarMalaysia2 extends Component {
  state = {
    registered: {},
  };

  seminar = "malaysia"; // ✅ unique key for backend

  componentDidMount() {
    this.fetchRegistered();
    // Auto-refresh every 10 seconds
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Fetch the current registration data
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error("Failed to fetch Malaysia registrations:", err);
    }
  };

  // ✅ Handle registration/unregistration
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      // 🔐 Ask for admin PIN before unregister
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });

      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      // ✅ Register a participant
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Render participant with color based on status
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔴 Registered / 🔵 Not registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Malaysia Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "Mr.Swee Sang Choong")}
        <br />
        {this.renderParticipant(2, "Ms.Jacky Chine")}
        <br />
        {this.renderParticipant(3, "Ms.Myanh Pham")}
        <br />
        {this.renderParticipant(4, "Mr.Daniel Wong")}
        <br />
        {this.renderParticipant(5, "Ms.Femie Fong")}
        <br />
        {this.renderParticipant(6, "Mr.Ryoma Watanabe")}
        <br />
        {this.renderParticipant(7, "Mr.Kelvin Tan")}
        <br />

        <div>
          ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...
        </div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarMalaysia2;
